import Vue from 'vue'

// O <span class="caret"> que o Materialize desenha fica por cima do lado
// direito do campo, mas NAO e o elemento onde o plugin dropdown registra o
// clique (esse e o <input class="select-dropdown">). Sem este delegate, clicar
// exatamente na setinha nao abre nada.
//
// Delegate global registrado uma unica vez para nao empilhar handler a cada
// mount de um material-select.
$(function () {
  $(document)
    .off('mousedown.materialSelectCaret')
    .off('click.materialSelectCaret')
    // Dentro de um modal o campo abria no focus e fechava logo em seguida no
    // blur, no mesmo clique: algo devolvia o foco para o modal e o Materialize
    // fecha o dropdown no blur. O preventDefault no mousedown impede a troca
    // de foco, e a abertura passa a ser feita explicitamente no click abaixo.
    // Vale para a setinha e para o proprio campo.
    .on('mousedown.materialSelectCaret', '.select-wrapper span.caret, .select-wrapper input.select-dropdown', function (e) {
      e.preventDefault();
    })
    .on('click.materialSelectCaret', '.select-wrapper span.caret, .select-wrapper input.select-dropdown', function (e) {

      e.preventDefault();
      e.stopPropagation();

      var $alvo = $(this);
      var $input = $alvo.is('input.select-dropdown')
        ? $alvo
        : $alvo.siblings('input.select-dropdown');

      if (!$input.length || $input.is(':disabled')) {
        return;
      }

      // placeDropdown/hideDropdown do Materialize mantem a classe 'active' no
      // origin, entao ela e a fonte de verdade de "esta aberto".
      if ($input.hasClass('active')) {
        $input.trigger('close');
        return;
      }

      // Abre pelo mesmo evento que o handler de focus do Materialize usa.
      // O parametro 'focus' faz o plugin marcar isFocused, evitando que o
      // proprio handler de click dele trate isso como um toggle e feche.
      $input.trigger('open', ['focus']);
    });
});

Vue.component("material-select", {
  name: 'material-select',
  template: '<select><slot></slot></select>',
  props: ['value'],
  watch: {
    value: function (value) {

      // Trocar o valor nao precisa reconstruir o widget: basta sincronizar o
      // rotulo e o <li> ativo.
      this.syncValue(value);
    }
  },
  methods: {

    // Assinatura das <option> atuais. Serve para detectar se o update do Vue
    // realmente mexeu na lista ou se foi so um re-render do pai.
    optionsSignature: function () {

      var sig = [];

      $(this.$el).find('option').each(function () {
        sig.push([this.value, this.text, this.disabled]);
      });

      return JSON.stringify(sig);
    },

    syncValue: function (value) {

      var $select = $(this.$el);
      var v = (value === undefined) ? this.value : value;

      $select.val(v === null || v === undefined ? '' : v);

      var el = $select[0];
      var $wrapper = $select.closest('.select-wrapper');
      var $input = $wrapper.find('input.select-dropdown');

      if (!$input.length) {
        return;
      }

      var index = el.selectedIndex;

      $input.val(index >= 0 ? $(el.options[index]).text() : '');

      // O Materialize indexa os <li> ignorando os de optgroup.
      var $itens = $wrapper.find('ul.select-dropdown > li:not(.optgroup)');

      $itens.removeClass('active');

      if (index >= 0) {
        $itens.eq(index).addClass('active');
      }
    },

    rebuild: function () {

      var $select = $(this.$el);
      var v = this.value;

      // O Materialize monta o rotulo a partir de option:selected, entao o
      // valor precisa estar aplicado antes de reconstruir.
      $select.val(v === null || v === undefined ? '' : v);

      $select.material_select('destroy');
      $select.material_select();

      // O Materialize so marca o <li> com a classe 'active' no clique, entao
      // apos reconstruir a lista abriria sem realcar a opcao ja selecionada.
      this.syncValue();

      this._lastSignature = this.optionsSignature();
    }
  },
  mounted: function () {

    var vm = this;
    var $select = $(this.$el);

    $select
      .val(this.value)
      .on('change', function () {

        vm.$emit('input', this.value);

        // O Materialize fechava a lista no blur do input. Como agora impedimos
        // a troca de foco (para o dropdown nao fechar sozinho ao abrir), esse
        // blur nao acontece mais e a lista ficava aberta apos escolher uma
        // opcao, dando a impressao de que nada tinha sido selecionado.
        if (!this.multiple) {
          $(this).closest('.select-wrapper')
            .find('input.select-dropdown')
            .trigger('close');
        }
      });

    $select.material_select();

    this.syncValue();

    this._lastSignature = this.optionsSignature();
  },
  updated: function () {

    // material_select('destroy') + material_select() remonta o widget inteiro
    // e descarta o <ul> aberto. Rodar isso a cada updated() fazia o dropdown
    // sumir embaixo do cursor sempre que qualquer dado reativo da tela mudava
    // (chegada de options por AJAX, spinner, total recalculado), obrigando o
    // usuario a clicar de novo. So reconstroi quando a lista mudou de fato.
    if (this.optionsSignature() === this._lastSignature) {
      this.syncValue();
      return;
    }

    this.rebuild();
  },
  destroyed: function () {

    $(this.$el).material_select('destroy');
  }
});



// WEBPACK FOOTER //
// ./src/components/Shared/Material/MaterialSelect.js